import React, {useState, useContext, useEffect} from 'react'
import { ThemeContext } from './Context.jsx'
import './Common.module.css'
import * as style from './Items.module.css'

export const SegmentedControl = ({ categories, onSelectCategory }) => {
  const [ theme, setTheme ] = useContext(ThemeContext)
  const [ blockPos, setBlockPos ] = useState(1)
  const [ activeCategory, setActiveCategory ] = useState(categories[0])

  const handleCategorySelection = (item, index) => {
    onSelectCategory(categories[index])
    setActiveCategory(categories[index])
    setBlockPos(parseInt(100/categories.length)*index)
  }

  useEffect(() => {
  }, []);

  return (
    <div style={{ backgroundColor: theme.bg }} className={style.segmentedControlContainer} style={{ backgroundColor: theme.nselbg, border: "2px solid "+theme.nselbor }}>
      <div className={style.highlightBlock}
        style={{
          backgroundColor: theme.sfg,
          marginLeft: blockPos+"%",
          border: "2px inset "+theme.ptxt
        }}
      ></div>
      <div className={style.segmentedControlTabsContainer}>
        {  categories.map((item, index) => {
          return (
            <div className={style.segmentedControlItemContainer} onClick={(item) => { handleCategorySelection(item, index) }} key={index + 1}>
              <div className={style.segmentedControlItem}>
                <span style={{
                    color: activeCategory === item ? theme.ptxt : theme.sfg,
                    transition: 'color .3s ease .3s',
                }}>
                    { item }
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
